import { render, staticRenderFns } from "./BoardName.vue?vue&type=template&id=e119e428&scoped=true"
import script from "./BoardName.vue?vue&type=script&lang=js"
export * from "./BoardName.vue?vue&type=script&lang=js"
import style0 from "./BoardName.vue?vue&type=style&index=0&id=e119e428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e119e428",
  null
  
)

export default component.exports